<app-header></app-header>
<section class="banner pt-10 border" [style.font-family]="'var(--vex-font)'">
  <div style="position: relative">
    <div class="md:py-5">
      <div class="text-center md:my-5">
        <div class="banner-text">
          Ensuring An
          <img src="./assets/images/banner-text-animation.gif" alt="" class="main-image-banner px-4 md:p-0"><br>
          & User-Friendly Admission
        </div>
      </div>
    </div>
    <div class="">
      <img src="./assets/images/face-one.png" class="face-one" alt="" style="position: absolute">
      <img src="./assets/images/face-two.png" class="face-two" alt="" style="position: absolute">
      <img src="./assets/images/face-three.png" class="face-three" alt="" style="position: absolute">
      <img src="./assets/images/face-four.png" class="face-four" alt="" style="position: absolute">
      <img src="./assets/images/name-one.png" class="name-one" alt="" style="position: absolute">
      <img src="./assets/images/name-two.png" class="name-two" alt="" style="position: absolute">
    </div>
    <div class="flex trusted items-center justify-center  w-25 my-5 py-5 m-auto">
      <img src="./assets/images/banner-group.png" class=" md:mb-0 pr-5" alt="">
      <p class="group-text mp-0 flex items-center ">
        Trusted already by 1.2k+
      </p>
    </div>
    <div class="flex items-center justify-center subheading-2 transition-all duration-200 rounded-lg px-4 py-2 md:py-4">
      <button
        class="banner-btn-two p-25px whitespace-nowrap bg-blue-500 text-white highlight-button bg-[#6752A9] rounded-lg px-4 py-2 flex items-center justify-center"
        mat-flat-button type="button"
        (click)="goTo('auth/register')">
        <i class="fa fa-building-columns mr-3px fa-bounce f-20px"></i> <span
        class="f-20px"> Add Your Organisation</span>
      </button>
    </div>
    <div class="px-2 md:px-5 md:mt-0 mt-5 image-position">
      <div class="">
        <img src="./assets/images/Landing-page/banner-video-img.png" class="mx-auto" alt="">
      </div>
    </div>
  </div>
</section>

<section class="container pt-18 md:pt-52 mt-10 md:mt-36" [style.font-family]="'var(--vex-font)'">
  <div class="mt-40 md:mt-36">
    <div>
      <p class="text-center font-semibold text-3xl md:text-5xl">
        Cutting-Edge Technology, Effortless<span class="text-maroon"> Admissions</span>
      </p>
      <p class="text-center mt-4 text-lg md:text-xl">
        See how Enroll streamlines your workflow, delivering top-notch performance and reliability.
      </p>
    </div>
  </div>

  <div class="mt-8 md:mt-20 flex flex-col md:flex-row">
    <div class="md:w-7/12">
      <div class="p-5 flex flex-col h-full">
        <div class="bg-white shadow-md rounded-lg overflow-hidden flex-1">
          <div class="p-4">
            <h6 class="text-lg py-2 font-bold text-maroon">Integrated Lead Management</h6>
            <p class="text-gray-700 text-justify">Automatically import leads from various sources, assign them to the
              right team
              members, and monitor their progress through the admissions pipeline.</p>
          </div>
          <div class="mt-4">
            <img src="./assets/images/social-animation.gif" alt="Social Animation" class="w-full h-auto">
          </div>
        </div>
      </div>
    </div>

    <div class="md:w-5/12">
      <div class="p-5 flex flex-col h-full">
        <div class="bg-white shadow-md rounded-lg overflow-hidden flex-1">
          <div class="p-4">
            <h6 class="text-lg py-2 font-bold text-maroon">Seamless Sales Integration</h6>
            <p class="text-gray-700 text-justify">Manage communications, track interactions, and close deals faster. All
              your sales
              data in one place!</p>
          </div>
          <div class="flex items-center justify-center flex-1">
            <div class="seamless-inner">
              <div class="border-one border-gray-300 border-solid">
                <div class="border-two border-gray-300 border-solid">
                  <div class="border-three p-2">
                    <div class="students m-auto mt-3 text-start p-3">
                      <img src="./assets/images/inner-graph-animation.gif" alt="Inner Graph Animation"
                           class="rounded-lg">
                    </div>
                    <div class="students mb-3 mt-3">
                      <img src="./assets/images/follow-up.gif" alt="Follow Up Animation" class="rounded-lg">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col md:flex-row mt-2">
    <div class="md:w-5/12">
      <div class="p-5 h-full flex flex-col">
        <div class="bg-white shadow-md rounded-lg overflow-hidden flex-grow">
          <div class="p-4">
            <h6 class="text-lg py-2 font-bold text-maroon">Efficient Session Management</h6>
            <p class="text-gray-700 text-justify">Our session management tools help you coordinate class times, assign
              instructors,
              and ensure that everything runs smoothly.</p>
          </div>
          <div class="social-animation pt-10">
            <div class="border-one">
              <div class="border-two">
                <div class="border-three">
                  <img src="./assets/images/border.png" alt="Border Image" class="img-fluid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md:w-7/12">
      <div class="p-5 h-full flex flex-col">
        <div class="bg-white shadow-md rounded-lg overflow-hidden flex-grow">
          <div class="p-4">
            <h6 class="text-lg py-2 font-bold text-maroon">Reporting & Analytics</h6>
            <p class="text-justify">Generate detailed reports on leads, admissions, financials, and more to gain
              insights and improve your
              processes.</p>
          </div>
          <div class="pt-10">
            <div class="flex items-center justify-center">
              <div class="reporting">
                <div class="border-one">
                  <div class="border-two">
                    <div class="border-three p-3 pb-0">
                      <img src="./assets/images/graph-animation.gif" alt="Graph Animation"
                           class="img-fluid graph-animation">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="features mt-12 md:mt-16 pt-5" style="font-family: var(--vex-font);">
  <div class="section-header text-center">
    <p class="text-2xl md:text-4xl font-bold text-primary">
      <span class="text-maroon">Powerful Features</span>, Seamless Experience
    </p>
    <p class="mt-4 text-lg md:text-xl text-secondary text-center">
      Discover how Enroll transforms your admission workflow and unlock the full potential of your admission process.
    </p>
  </div>
  <div class="feature-content mt-10">
    <div class="container mx-auto px-4">
      <div class="md:hidden">
        <div class="accordion">
          <input type="checkbox" id="section1" class="accordion-checkbox hidden"/>
          <label for="section1" class="accordion-label">
            Application Management
          </label>
          <div class="accordion-content">
            <div class="flex flex-col items-center">
              <div class="p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3"
                       alt="Application Management Icon">
                  <p class="text-2xl font-semibold">
                    Application Management
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Streamline your admissions with our intuitive application portal. Simplify the submission, review, and
                  approval process, making it easy for both applicants and administrators. With user-friendly features
                  and real-time updates, manage applications efficiently and ensure a seamless experience from start to
                  finish. Empower your team to handle admissions effortlessly, enhancing productivity and improving the
                  applicant journey.
                </p>
              </div>
              <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                   alt="Application Management Image">
            </div>
          </div>

          <input type="checkbox" id="section2" class="accordion-checkbox hidden"/>
          <label for="section2" class="accordion-label">
            Communication Hub
          </label>
          <div class="accordion-content">
            <div class="flex flex-col items-center">
              <div class="p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3" alt="Communication Hub Icon">
                  <p class="text-2xl font-semibold">
                    Communication Hub
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Centralize all communications with prospective students through various channels. Our Communication
                  Hub streamlines interactions, ensuring no message is missed. Engage seamlessly via email, SMS, and
                  social media, all from one unified platform. Enhance your outreach and build stronger relationships
                  with ease. Simplify your communication workflow and keep every conversation organized and accessible.
                  Elevate your admission process with our comprehensive Communication Hub.
                </p>
              </div>
              <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                   alt="Communication Hub Image">
            </div>
          </div>

          <input type="checkbox" id="section3" class="accordion-checkbox hidden"/>
          <label for="section3" class="accordion-label">
            Analytics and Reporting
          </label>
          <div class="accordion-content">
            <div class="flex flex-col items-center">
              <div class="p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3"
                       alt="Analytics and Reporting Icon">
                  <p class="text-2xl font-semibold">
                    Analytics and Reporting
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Gain actionable insights with advanced analytics and customizable reports. Transform raw data into
                  meaningful metrics that drive informed decision-making. Monitor performance, identify trends, and
                  uncover opportunities to enhance your admission process. Our powerful analytics tools provide
                  real-time data visualization and detailed reports tailored to your institution's needs, ensuring you
                  stay ahead in a competitive educational landscape. Empower your team with the information they need to
                  succeed.
                </p>
              </div>
              <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                   alt="Analytics and Reporting Image">
            </div>
          </div>

          <input type="checkbox" id="section4" class="accordion-checkbox hidden"/>
          <label for="section4" class="accordion-label">
            Social Media Leads
          </label>
          <div class="accordion-content">
            <div class="flex flex-col items-center">
              <div class="p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3" alt="Social Media Leads Icon">
                  <p class="text-2xl font-semibold">
                    Social Media Leads
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Effortlessly manage your social media leads with our intuitive application portal. Streamline the
                  submission, review, and approval process to enhance efficiency and accuracy. Our platform centralizes
                  all your leads, ensuring seamless integration and easy access. Stay organized and make data-driven
                  decisions with advanced tracking and reporting tools, allowing you to focus on engaging and converting
                  prospects into successful enrollments.
                </p>
              </div>
              <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                   alt="Social Media Leads Image">
            </div>
          </div>
        </div>
      </div>

      <div class="md:block hidden">
        <mat-tab-group class="w-full">
          <mat-tab class="text-center">
            <ng-template mat-tab-label>
              <i class="fa fa-buysellads" aria-hidden="true"></i> &nbsp;
              Application Management
            </ng-template>
            <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
              <div class="md:w-1/2 p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3"
                       alt="Application Management Icon">
                  <p class="text-2xl font-semibold">
                    Application Management
                  </p>
                </div>
                <p class="text-primary text-justify">
                  Streamline your admissions with our intuitive application portal. Simplify the submission, review, and
                  approval process, making it easy for both applicants and administrators. With user-friendly features
                  and real-time updates, manage applications efficiently and ensure a seamless experience from start to
                  finish. Empower your team to handle admissions effortlessly, enhancing productivity and improving the
                  applicant journey.
                </p>
              </div>
              <div class="md:w-1/2 p-4 flex justify-center">
                <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                     alt="Application Management Image">
              </div>
            </div>
          </mat-tab>
          <mat-tab class="text-center">
            <ng-template mat-tab-label>
              <i class="fa fa-retweet" aria-hidden="true"></i> &nbsp;
              Communication Hub
            </ng-template>
            <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
              <div class="md:w-1/2 p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3" alt="Communication Hub Icon">
                  <p class="text-2xl font-semibold">
                    Communication Hub
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Centralize all communications with prospective students through various channels. Our Communication
                  Hub streamlines interactions, ensuring no message is missed. Engage seamlessly via email, SMS, and
                  social media, all from one unified platform. Enhance your outreach and build stronger relationships
                  with ease. Simplify your communication workflow and keep every conversation organized and accessible.
                  Elevate your admission process with our comprehensive Communication Hub.
                </p>
              </div>
              <div class="md:w-1/2 p-4 flex justify-center">
                <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                     alt="Communication Hub Image">
              </div>
            </div>
          </mat-tab>
          <mat-tab class="text-center" label="">
            <ng-template mat-tab-label>
              <i class="fa fa-line-chart" aria-hidden="true"></i> &nbsp;
              Analytics and Reporting
            </ng-template>
            <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
              <div class="md:w-1/2 p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3"
                       alt="Analytics and Reporting Icon">
                  <p class="text-2xl font-semibold">
                    Analytics and Reporting
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Gain actionable insights with advanced analytics and customizable reports. Transform raw data into
                  meaningful metrics that drive informed decision-making. Monitor performance, identify trends, and
                  uncover opportunities to enhance your admission process. Our powerful analytics tools provide
                  real-time data visualization and detailed reports tailored to your institution's needs, ensuring you
                  stay ahead in a competitive educational landscape. Empower your team with the information they need to
                  succeed.
                </p>
              </div>
              <div class="md:w-1/2 p-4 flex justify-center">
                <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                     alt="Analytics and Reporting Image">
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Social Media Leads">
            <ng-template mat-tab-label>
              <i class="fa fa-handshake" aria-hidden="true"></i> &nbsp;
              Social Media Leads
            </ng-template>
            <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
              <div class="md:w-1/2 p-4">
                <div class="flex items-center mb-4">
                  <img src="./assets/images/features-icon-dim.png" class="h-8 w-8 mr-3" alt="Social Media Leads Icon">
                  <p class="text-2xl font-semibold">
                    Social Media Leads
                  </p>
                </div>
                <p class="text-base text-primary text-justify">
                  Effortlessly manage your social media leads with our intuitive application portal. Streamline the
                  submission, review, and approval process to enhance efficiency and accuracy. Our platform centralizes
                  all your leads, ensuring seamless integration and easy access. Stay organized and make data-driven
                  decisions with advanced tracking and reporting tools, allowing you to focus on engaging and converting
                  prospects into successful enrollments
                </p>
              </div>
              <div class="md:w-1/2 p-4 flex justify-center">
                <img src="./assets/images/feature-img-div-one.png" class="img-fluid rounded-lg shadow-lg"
                     alt="Social Media Leads Image">
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</section>

<section class="software-free mt-24 pt-8" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4">
    <div class="section-heading">
      <p class="text-2xl font-bold md:text-4xl text-center">
        Get Our Software - Sign Up, <span class="text-maroon">NOW!</span>
      </p>
      <p class="text-center text-secondary mt-4 text-lg md:text-xl mt-3">
         See Enroll in action and discover its full potential
      </p>
    </div>
    <div class="inner-div flex justify-center sm:flex md:hidden lg:hidden">
      <div class="inner-child p-5 pb-0 max-w-screen-md">
        <div class="mb-4">
          <img src="./assets/images/inner-left-img.png" class="w-full h-auto" alt="Inner Image">
        </div>

        <div class="p-10 text-center">
          <p class="text-lg  mb-4 text-justify text-zinc-500">
            The system for managing admissions oversees the gathering of student applications and documentation,
            and shortlists applicants for online processing.
          </p>
          <ul class="list-disc list-inside mb-6 text-zinc-500">
            <li class="mb-2">
              User-Friendly Interface
            </li>
            <li class="mb-2">
              Automated Online Software System
            </li>
            <li class="mb-2">
              Get Real-Time Report
            </li>
            <li class="mb-2">
              Accurate and Reliable Data
            </li>
          </ul>
          <div class="flex justify-center">
            <button
              class="flex items-center px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition whitespace-nowrap duration-200"
              (click)="goTo('auth/register')">
              Experience it Now
              <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ml-2" alt="Arrow Icon">
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-div hidden md:block lg:block">
      <div class="inner-child p-5 pb-0">
        <div class="row">
          <div class="col-md-6 position-relative" style="height: 500px">
            <div class="inner-left position-absolute">
              <div class="inner-two py-4">
                <img src="./assets/images/inner-left-img.png" class="img-fluid" alt="">
              </div>
            </div>
          </div>
          <div class="col-md-6 py-10 p-10">
            <div class="row">
              <p class="ml-11px f-20px fw-400 text-justify">
                The system for managing admissions oversees the gathering of student applications and documentation,
                and shortlists applicants for online processing.
              </p>
            </div>
            <ul class="list-unstyled">
              <li>
                <div class="flex align-items-center">
                  <img src="./assets/images/list-bullet.png" alt="" srcset="">
                  <p class="mp-0 ms-2">
                    User-Friendly Interface
                  </p>
                </div>
              </li>
              <li>
                <div class="flex align-items-center">
                  <img src="./assets/images/list-bullet.png" alt="" srcset="">
                  <p class="mp-0 ms-2">
                    Automated Online Software System
                  </p>
                </div>
              </li>
              <li>
                <div class="flex align-items-center">
                  <img src="./assets/images/list-bullet.png" alt="" srcset="">
                  <p class="mp-0 ms-2">
                    Get Real-Time Report
                  </p>
                </div>
              </li>
              <li>
                <div class="flex align-items-center">
                  <img src="./assets/images/list-bullet.png" alt="" srcset="">
                  <p class="mp-0 ms-2">
                    Accurate and Reliable Data
                  </p>
                </div>
              </li>
            </ul>
            <button class="flex mt-5 items-center justify-center" (click)="goTo('auth/register')">
              Experience it Now
              <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ms-2" alt="" srcset="">
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="below-inner m-auto my-12 p-6 position-relative hidden sm:hidden md:flex lg:flex">
      <h3 class="text-center mx-auto">
        Discover the Power of Enroll’s AMS Software Modules
      </h3>
      <div class="row discover-row mt-28">
        <div class="col-md-4 p-3 discover-child child-one">
          <div class="flex items-center justify-center">
            <img src="./assets/images/manage.png" alt="">
            <div class="ms-4 cursor-pointer" (click)="goTo('/features')">
              <p class="mp-0 discover-inner-title">
                Efficiency Unleashed
              </p>
              <p class="mp-0 mt-3 flex inner-link-yellow">
                Learn More
                <img src="./assets/images/right-yellow.png" class="ms-3" alt="">
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-3 discover-child child-two">
          <div class="flex items-center justify-center">
            <img src="./assets/images/manage-two.png" class="" alt="">
            <div class="ms-4 cursor-pointer" (click)="goTo('/features')">
              <p class="mp-0 discover-inner-title">
                Smart Solutions
              </p>
              <p class="mp-0 mt-3 flex inner-link-yellow inner-link-blue">
                Learn More
                <img src="./assets/images/blue-arrow.png" class="ms-3" alt="">
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-3 discover-child child-three">
          <div class="flex items-center justify-center">
            <img src="./assets/images/manage-three.png" alt="">
            <div class="ms-4 cursor-pointer" (click)="goTo('/features')">
              <p class="mp-0 discover-inner-title">
                Streamlined Success
              </p>
              <p class="mp-0 flex mt-3 inner-link-yellow inner-link-red">
                Learn More
                <img src="./assets/images/red-arrow.png" class="ms-3" alt="">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto my-10 md:hidden lg:hidden p-6 rounded-xl"
         [style]="'background: var(--brand-primary)'">
      <div class="text-center mb-5">
        <h3 class="text-xl font-bold text-white">Discover the Power of Enroll’s AMS Software Modules</h3>
      </div>
      <div class="flex flex-wrap justify-center">
        <div class="w-full sm:w-1/3 p-3">
          <div class="flex items-center justify-center bg-white shadow-lg rounded-lg p-6">
            <img src="./assets/images/manage.png" alt="Manage Icon" class="w-12 h-12">
            <div class="ml-4">
              <p class="mb-1 text-lg font-medium">Manage & Regulate Session</p>
              <p class="flex items-center text-sm text-gray-600">
                Learn More
                <img src="./assets/images/right-yellow.png" alt="Right Arrow" class="ml-2 w-4 h-4">
              </p>
            </div>
          </div>
        </div>
        <div class="w-full sm:w-1/3 p-3">
          <div class="flex items-center justify-center bg-white shadow-lg rounded-lg p-6">
            <img src="./assets/images/manage-two.png" alt="Manage Two Icon" class="w-12 h-12">
            <div class="ml-4">
              <p class="mb-1 text-lg font-medium">Manage & Regulate Session</p>
              <p class="flex items-center text-sm text-gray-600">
                Learn More
                <img src="./assets/images/blue-arrow.png" alt="Right Arrow" class="ml-2 w-4 h-4">
              </p>
            </div>
          </div>
        </div>
        <div class="w-full sm:w-1/3 p-3">
          <div class="flex items-center justify-center bg-white shadow-lg rounded-lg p-6">
            <img src="./assets/images/manage-three.png" alt="Manage Three Icon" class="w-12 h-12">
            <div class="ml-4">
              <p class="mb-1 text-lg font-medium">Manage & Regulate Session</p>
              <p class="flex items-center text-sm text-gray-600">
                Learn More
                <img src="./assets/images/red-arrow.png" alt="Right Arrow" class="ml-2 w-4 h-4">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="mt-16 few-steps" [style.font-family]="'var(--vex-font)'">
  <div class="section-heading p-5">
    <p class="text-2xl md:text-4xl font-bold text-center">Few <span class="text-maroon">Easy</span>  Steps and Done</p>
    <p class="text-lg md:text-xl text-secondary text-center mt-3">
      Help users discover and understand your product’s value across their entire journey, from new user to power
      user.
    </p>
  </div>
  <div class="feature-content mt-4">
    <div class="container mx-auto px-4">
    <!--  <h2 class="text-3xl text-center mb-8">Easy Steps to Get Started</h2>-->
      <mat-tab-group class="w-full hidden md:block">
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="fa fa-building-columns fa-shake duration-[4000] mr-3px"></i>
            Add Your Organisation
          </ng-template>
          <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
            <div class="md:w-1/2 p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/add-organization-stepper.png" class="h-64 w-auto mr-3"
                     alt="Add Your Organisation Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Begin by adding detailed information about your organisation. This step is crucial as it sets up your
                account and enables you to manage all aspects of admissions seamlessly. Provide comprehensive details to
                streamline the application process for prospective students and ensure accurate information for
                administrative tasks.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Describe how this process helps users and why it's essential for them to complete it. Highlight the
                benefits of providing detailed organisational information, such as improving transparency and enhancing
                application efficiency.
              </p>
            </div>
            <div class="md:w-1/2 p-4 flex justify-center">
              <img src="./assets/images/Landing-page/addOrg.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Add Your Organisation Image">
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="fa-regular fa-circle-check fa-fade mr-3px"></i>
            Verify
          </ng-template>
          <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
            <div class="md:w-1/2 p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/Verify-stepper.png" class="h-64 w-auto mr-3" alt="Verify Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Verify the details provided during the organisation setup to ensure accuracy and authenticity. This step
                is essential to maintain data integrity and to proceed with the next stages of the admission process
                smoothly. Verification ensures that all information meets the required standards, enhancing trust and
                reliability.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Explain how accurate verification helps in reducing errors and maintaining a reliable database for
                better decision-making and communication with applicants.
              </p>
            </div>
            <div class="md:w-1/2 p-4 flex justify-center">
              <img src="./assets/images/Landing-page/verify.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Verify Image">
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="fa-solid fa-indian-rupee-sign fa-flip mr-3px"></i>
            Choose Plan
          </ng-template>
          <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
            <div class="md:w-1/2 p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/choos-%20plan-stepper.png" class="h-64 w-auto mr-3" alt="Choose Plan Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Select the best-suited plan for your organisation's needs. Evaluate different options based on features,
                scalability, and budget considerations. Choosing the right plan ensures that you optimize resources
                effectively and cater to specific requirements, setting a strong foundation for successful admissions
                management.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Describe how selecting the right plan can streamline operations and enhance efficiency in managing
                admissions, ensuring sustainable growth and scalability for your institution.
              </p>
            </div>
            <div class="md:w-1/2 p-4 flex justify-center">
              <img src="./assets/images/Landing-page/choose-plan.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Choose Plan Image">
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="fa-solid fa-sign-hanging fa-fade mr-3px"></i>
            Explore Dashboard
          </ng-template>
          <div class="flex flex-col md:flex-row items-center md:items-start mt-5">
            <div class="md:w-1/2 p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/explore-dashboard-stepper.png" class="h-64 w-auto mr-3"
                     alt="Explore Dashboard Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Dive into your personalized dashboard where you can efficiently manage applications, track analytics,
                and communicate with applicants. The dashboard provides real-time insights and tools to streamline
                operations, ensuring a seamless experience for both administrators and applicants.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Explain how the dashboard enhances user experience by providing intuitive tools and analytics for
                effective decision-making and management of admissions processes.
              </p>
            </div>
            <div class="md:w-1/2 p-4 flex justify-center">
              <img src="./assets/images/Landing-page/dashboard.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Explore Dashboard Image">
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
      <div class="block md:hidden border-purple-solid p-4">
        <div class="text-center">
          <p class="text-xl font-bold text-maroon pb-2">Step 1</p>
          <i class="fas fa-arrow-down pb-2 text-maroon text-3xl"></i>
        </div>
        <input type="checkbox" id="tab1" class="hidden">
        <label for="tab1" class="accordion-label">
          <i class="fa fa-building-columns fa-shake mr-3"></i>
          Add Your Organisation
        </label>
        <div class="accordion-content">
          <div class="flex flex-col items-center md:items-start mt-5">
            <div class="p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/add-organization-stepper.png" class="h-64 w-auto mr-3"
                     alt="Add Your Organisation Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Begin by adding detailed information about your organisation. This step is crucial as it sets up your
                account and enables you to manage all aspects of admissions seamlessly. Provide comprehensive details to
                streamline the application process for prospective students and ensure accurate information for
                administrative tasks.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Describe how this process helps users and why it's essential for them to complete it. Highlight the
                benefits of providing detailed organisational information, such as improving transparency and enhancing
                application efficiency.
              </p>
            </div>
            <div class="p-4 flex justify-center">
              <img src="./assets/images/Landing-page/addOrg.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Add Your Organisation Image">
            </div>
          </div>
        </div>
        <div class="text-center">
          <p class="text-xl font-bold text-maroon pb-2">Step 2</p>
          <i class="fas fa-arrow-down pb-2 text-maroon text-3xl"></i>
        </div>
        <input type="checkbox" id="tab2" class="hidden">
        <label for="tab2" class="accordion-label">
          <i class="fa-regular fa-circle-check fa-fade mr-3"></i>
          Verify
        </label>
        <div class="accordion-content">
          <div class="flex flex-col items-center md:items-start mt-5">
            <div class="p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/Verify-stepper.png" class="h-64 w-auto mr-3" alt="Verify Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Verify the details provided during the organisation setup to ensure accuracy and authenticity. This step
                is essential to maintain data integrity and to proceed with the next stages of the admission process
                smoothly. Verification ensures that all information meets the required standards, enhancing trust and
                reliability.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Explain how accurate verification helps in reducing errors and maintaining a reliable database for
                better decision-making and communication with applicants.
              </p>
            </div>
            <div class="p-4 flex justify-center">
              <img src="./assets/images/Landing-page/verify.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Verify Image">
            </div>
          </div>
        </div>
        <div class="text-center">
          <p class="text-xl font-bold text-maroon pb-2">Step 3</p>
          <i class="fas fa-arrow-down pb-2 text-maroon text-3xl"></i>
        </div>
        <input type="checkbox" id="tab3" class="hidden">
        <label for="tab3" class="accordion-label">
          <i class="fa-solid fa-indian-rupee-sign fa-flip mr-3"></i>
          Choose Plan
        </label>
        <div class="accordion-content">
          <div class="flex flex-col items-center md:items-start mt-5">
            <div class="p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/choos-%20plan-stepper.png" class="h-64 w-auto mr-3" alt="Choose Plan Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Select the best-suited plan for your organisation's needs. Evaluate different options based on features,
                scalability, and budget considerations. Choosing the right plan ensures that you optimize resources
                effectively and cater to specific requirements, setting a strong foundation for successful admissions
                management.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Describe how selecting the right plan can streamline operations and enhance efficiency in managing
                admissions, ensuring sustainable growth and scalability for your institution.
              </p>
            </div>
            <div class="p-4 flex justify-center">
              <img src="./assets/images/Landing-page/choose-plan.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Choose Plan Image">
            </div>
          </div>
        </div>
        <div class="text-center">
          <p class="text-xl font-bold text-maroon pb-2">Step 4</p>
          <i class="fas fa-arrow-down pb-2 text-maroon text-3xl"></i>
        </div>
        <input type="checkbox" id="tab4" class="hidden">
        <label for="tab4" class="accordion-label">
          <i class="fa-solid fa-sign-hanging fa-fade mr-3"></i>
          Explore Dashboard
        </label>
        <div class="accordion-content">
          <div class="flex flex-col items-center md:items-start mt-5">
            <div class="p-4">
              <div class="flex items-center mb-4">
                <img src="./assets/images/explore-dashboard-stepper.png" class="h-64 w-auto mr-3"
                     alt="Explore Dashboard Icon">
              </div>
              <p class="text-base text-primary text-justify text-zinc-500">
                Dive into your personalized dashboard where you can efficiently manage applications, track analytics,
                and communicate with applicants. The dashboard provides real-time insights and tools to streamline
                operations, ensuring a seamless experience for both administrators and applicants.
              </p>
              <p class="text-base text-primary text-justify text-zinc-500">
                Explain how the dashboard enhances user experience by providing intuitive tools and analytics for
                effective decision-making and management of admissions processes.
              </p>
            </div>
            <div class="p-4 flex justify-center">
              <img src="./assets/images/Landing-page/dashboard.svg" class="img-fluid rounded-lg shadow-lg"
                   style="width: 592px; height: 490px;" alt="Explore Dashboard Image">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="complimentry-offerings p-4 py-8 mt-24" [style.font-family]="'var(--vex-font)'">
    <div class="container p-5">
      <p class="text-center md:text-4xl md:mb-4 text-2xl font-bold">
        Complimentary <span class="text-maroon">offerings </span> from Us
      </p>
      <div class="hidden md:flex pt-8">
        <div class="col-lg-6">
          <div class="complimentry-left mt-5">
            <div class="flex items-center justify-center flex-wrap">
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img class="centered-image" src="./assets/images/comp-inner-one.png" alt="">
                  <p class="mp-0 mt-3 text-center">
                    Lifetime Free Maintenance
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img src="./assets/images/comp-inner-two.png" alt="" class="centered-image">
                  <p class="mp-0 mt-3 text-center">
                    Updates and Upgrades
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img src="./assets/images/comp-inner-three.png" alt="" class="centered-image">
                  <p class="mp-0 mt-3 text-center">
                    Free Server
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img src="./assets/images/comp-inner-four.png" alt="" class="centered-image">
                  <p class="mp-0 mt-3 text-center">
                    Personalized Assistance
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img src="./assets/images/comp-inner-five.png" alt="" class="centered-image">
                  <p class="mp-0 mt-3 text-center">
                    Resolution within 48 hours
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="complimentry-inner p-4">
                  <img src="./assets/images/comp-inner-six.png" alt="" class="centered-image">
                  <p class="mp-0 mt-3 text-center">
                    Discounts on Extra Modules
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 p-5">
          <div class="free-gift overflow-hidden m-auto">
            <img src="./assets/images/Landing-page/complimentry-offer.svg" class="img-fluid m-auto" alt="">
          </div>
        </div>
      </div>
      <div class="flex flex-col space-y-4 p-4 md:hidden">
        <div class="w-full p-4 flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-one.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Lifetime Free Maintenance
            </p>
          </div>
        </div>
        <div class="w-full p-4 flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-two.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Updates and Upgrades
            </p>
          </div>
        </div>
        <div class="w-full p-4 text-center flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-three.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Free Server
            </p>
          </div>
        </div>
        <div class="w-full p-4 text-center flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-four.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Personalized Assistance
            </p>
          </div>
        </div>
        <div class="w-full p-4 text-center flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-five.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Resolution within 48 hours
            </p>
          </div>
        </div>
        <div class="w-full p-4 text-center flex justify-center gap-x-4 rounded">
          <div class="complimentry-inner p-4">
            <img src="./assets/images/comp-inner-six.png" alt="" class="centered-image">
            <p class="mp-0 mt-3 text-center">
              Discounts on Extra Modules
            </p>
          </div>
        </div>
        <div class="w-full p-4 text-center flex justify-center rounded">
          <div class="free-gift overflow-hidden m-auto">
            <img src="./assets/images/free-gift.png" class="img-fluid m-auto" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="mt-12 few-steps" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row md:justify-between items-center text-center md:text-left">
      <div class="p-5 mb-4 md:mb-0 md:w-2/3 md:justify-start flex">
        <p class="text-2xl md:text-4xl font-bold">
          Take a look at our latest <span class="text-maroon">Blogs</span>
        </p>
      </div>
      <div class="md:w-1/3 md:justify-end flex p-5">
        <button
          class="flex items-center px-8 py-2 mt-5 md:mt-0 hover-btn bg-[#6752A9] text-white rounded-lg transition whitespace-nowrap duration-200"
          (click)="goTo('/blogs')">
          View All
          <img src="./assets/images/tilted-arrow.png" width="34" height="20" class="ml-2" alt="Arrow Icon">
        </button>
      </div>
    </div>
    <div class="container mx-auto md:py-4 py-0">
      <div class="flex flex-wrap -mx-4">
        <div *ngFor="let blog of blogs" class="w-full md:w-1/3 px-4 mb-6">
          <a href="/blog-details">
            <mat-card class="shadow-lg card-hover-effect blog-card">
              <img mat-card-image [src]="blog.image" alt="{{ blog.title }}" class="w-full h-48 object-cover">
              <mat-card-header>
                <mat-card-title>{{ blog.title }}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <p class="text-zinc-500 text-justify">{{blog.content}}</p>
              </mat-card-content>
              <span class="blog-date p-2 font-bold px-5 text-maroon" style="background: #FFF0FD;">Latest</span>
            </mat-card>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid mt-10 md:mt-20 bg-faq pb-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-2xl md:text-4xl font-semibold">
      Frequently Asked <span class="text-maroon">Questions</span>
    </p>
    <div class="flex flex-col md:flex-row justify-between items-center gap-8 pt-8">
      <div class="flex-1 flex-shrink-0">
        <img src="/assets/images/features-images/faq5.jpeg" alt="FAQ Image" class="w-full md:h-96 rounded-2xl"/>
      </div>
      <div class="flex-1 flex flex-col">
        <div class="flex-1 flex flex-col md:max-w-xl px-1 md:px-0">
          <mat-accordion class="p-2 flex-1">
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header class="flex items-center">
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                      What is Volmint’s Enroll?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 md:pt-0 md:mt-0 text-justify text-zinc-500">
                Volmint’s Enroll is an Admission Management System, that offers comprehensive admissions strategy
                services,
                including admission management, social media lead handling, and integrated sales processes, tailored to
                meet
                institutional needs with excellence and precision.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    How does Enroll work?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                It automates application submission, document management, and communication, ensuring efficiency and
                transparency. With intuitive features for administrators, applicants, and reviewers, Enroll simplifies
                complex
                workflows, enhances collaboration, and provides real-time insights to optimize admissions decisions.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                       Is Enroll safe for data security?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Absolutely. Enroll prioritizes data security with robust encryption protocols and secure cloud
                infrastructure.
                We adhere to industry standards to protect sensitive information throughout the admission process,
                ensuring
                confidentiality, integrity, and peace of mind for all users.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                     What are the features of Enroll?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Enroll offers several advanced features including a secured platform, advanced analytics, and powerful
                automation. the software offers online application management, document management, applicant tracking
                system,
                user management, analytics and reporting, and communication management.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                     Can we customize the product/service offered by Enroll?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Yes, you can choose among the various plans and get customization as per your requirements. Being one of
                the
                leading IT software companies, we are committed to providing the best solution to our customers at the
                best
                price.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                       What is the cost of the Enroll Admission Management system or there are any hidden charges?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                We will provide various plans as per the requirements of the business, you can choose any plan that
                suits your
                needs, and will charge accordingly. Volmint Technologies is proud to be a prestigious organisation and
                belief
                in transparency. Thus, we do not have any hidden charges policy.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                        Is there any refund or return available?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Concerning our admission management software, we provide a money-back guarantee. Within five working
                days of
                the purchase date, you can seek a refund if, for any reason, you are unhappy with your purchase.
                Moreover, you
                need to fulfill the refund policy, terms, and conditions.
              </p>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
<section class="above-footer py-12 p-lg-5" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="inner-container m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5">
        Ready to transform your admissions process?
      </h3>
      <p class="mt-4">
        Try our revolutionary software today!
      </p>

      <button type="button" class="mt-5 hover-btn  text-white  py-2 rounded" (click)="goTo('auth/register')">
        Take a Trial !
      </button>
    </div>
  </div>
</section>
<app-footer></app-footer>
